
<div *ngIf="showTooltip === true">
	<div class="bottom-toggle"></div>
	<span class="tooltip-span">
		<!-- {{tooltip |translate}} -->
	</span>
</div>

